import React, { useContext } from 'react';
import { DatePicker as MuiDatePicker } from '@material-ui/pickers';
import InputBase from '../InputBase';
import styled from 'styled-components/macro';
import useTranslations from '../../../hooks/useTranslations';
import { FormContext } from '../FormContext';
import ClearIcon from '@material-ui/icons/Clear';
import MuiIconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const DatePicker = styled(MuiDatePicker)`
  button[class*='MuiButtonBase'] {
    padding: 8px;
  }

  svg {
    width: 0.7em;
    height: 0.7em;
  }
`;

const IconButton = styled(MuiIconButton)`
  && {
    padding: 0 !important;
  }
`;

const DateFieldView = props => {
  const { validateField } = useContext(FormContext);
  const t = useTranslations();
  return (
    <>
      <DatePicker
        disabled={props.readOnly}
        disableFuture={props.disableFuture}
        disablePast={props.disablePast}
        autoOk
        TextFieldComponent={InputBase}
        variant="inline"
        inputVariant="outlined"
        format={props.dateFormat}
        // mask={props.dateFormat}
        value={props.value || null}
        emptyLabel={t('forms.field.date.placeholder')}
        onChange={props.onDateChange}
        onClose={() => {
          setTimeout(() => {
            validateField(props.internalId);
          }, 500);
        }}
        clearable
        InputProps={{
          endAdornment: (
            <Tooltip arrow title="Clear">
              <IconButton
                disabled={props.readOnly}
                onClick={e => {
                  e.stopPropagation();
                  props.onDateChange(null);
                }}
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          )
        }}
        inputProps={{ id: props.internalId }}
        InputAdornmentProps={{
          position: 'start'
        }}
      />
    </>
  );
};

export default DateFieldView;
